<template>
  <!-- 雷达图 -->
  <div :id="radarChartInfo.nodeId"></div>
</template>

<script>
export default {
  name: "RadarChart",
  props:["radarChartInfo"],
  data(){
    return {
    //   radarChartInfo:{
    //       nodeId:'ageDistribution',//节点
    //       max:[{text: '传播表现', max: 100},{text: '涨粉表现', max: 100},{text: '性价比表现', max: 100},{text: '任务表现', max: 100},{text: '种草表现', max: 100}],
    //       data1:[42, 30, 20, 35, 50, 18],
    //       data2:[30, 50, 60, 75, 90, 38],
    //       formatter:{}
    //   }
    }
  },
  computed:{
    
  },
  methods:{
    radarChart(radarChartInfo){
      this.$echarts.dispose(document.getElementById(radarChartInfo.nodeId));
      var myChart = this.$echarts.init(document.getElementById(radarChartInfo.nodeId));
      myChart.setOption({
        tooltip: {
            trigger: 'axis',
            // formatter:function(params){          
            //     return ('<div style="text-align:center;padding:0 8px;">虚线表示行业最低标准</div>')
            // },
            formatter:radarChartInfo.formatter
        },
        radar: [
            {
                indicator:radarChartInfo.max,
                center: ['50%', '50%'],//位置
                radius: 90,//大小
                name:{
                    formatter:'{value}',
                    // formatter: (value) => {
                    //     let d;
                    //     radarChartInfo.max.map((item) => {
                    //         if (item.name == value) {
                    //         d = item.value;
                    //         }
                    //     });
                    //     return [`${value}`, `${d}`].join("\n");
                    //     },
                    // 字体样式
                    textStyle:{
                        fontSize:14,
                        color:'#666'
                    }
                },
                //文字与图的距离
                nameGap: 10,
                //坐标轴线的设置
                axisLine: {
                    show: true,
                    lineStyle:{
                        color:'#eee',
                    },
                },
                splitLine: {
                    lineStyle: {
                        color:'#eee'//雷达线颜色
                    }
                },
                splitArea: {
                //分割区域的样式
                    areaStyle:{
                        color: ['#fff', '#fff', '#fff', '#fff','#fff'],
                    }
                }
            }
        ],
        series: [
            {
                type: 'radar',
                symbolSize: 9,
                tooltip: {
                    trigger: 'item'
                },
                data: [
                     {
                        value: radarChartInfo.data1,
                        name: '平均标准',
                        symbol: "none",
                        lineStyle: {
                            type: 'dashed',
                            color:"#2381ff",
                            width:1.5
                        }
                    },
                    {
                        value: radarChartInfo.data2,
                        name: '虚线表示行业平均标准',
                        areaStyle: {
                            normal: {
                                color: 'rgba(19,119,252,.15)' // 选择区域颜色
                            }
                        },
                        symbol:'circle',
                        itemStyle: {//拐点
                            normal: {
//                                 color: '#187cfd',
//                                 borderColor: '#187cfd',       // 拐点的描边颜色。[ default: '#000' ]
//                                 borderWidth:2,
//                                 shadowColor:'#187cfd',
//                                 shadowBlur:4,
                                    color: '#3f90fd',
                                    borderColor:'#d5e9ff',
                                    borderWidth:'2',
                                    shadowColor:'#71adfe',
                                    shadowBlur: 1
                            }
                        },
                        lineStyle: {
                            color: '#2381ff', // 雷达构成的区域边框
                        }
                    }
                ]
            }   
        ]    
      }) 
      
    },
    
  },
  components:{
   
  },
  watch:{
    
  },
  mounted() {
    this.radarChart(this.radarChartInfo)
  }
}
</script>

<style scoped>
  

</style>